





































import { NotificationSectionViewFactory } from '@/components/molecules/notification-section/model/notification-section-model'
import OrderListItem from '@spa/components/pages/order/order/order-list/read-only/OrderListItem.vue'
import { kind as OrderKind, Order } from '@spa/services/order'
import Vue, { VueConstructor } from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component({
  components: {
    OrderListItem,
  },
})
export default class ContinueToOrder extends Vue {
  @Prop({ required: true })
  orders: Order[]

  get notificationSection(): VueConstructor {
    return NotificationSectionViewFactory.create('alert', {
      type: 'with-title',
      title: 'カートにまだ商品が残っています！',
      body: this.alertMessage,
    })
  }

  get containsPreOrder(): boolean {
    return this.orders.some(o => this.isPreOrder(o))
  }

  get alertMessage(): string {
    return this.containsPreOrder ?
      '今のうちに決済、発送準備が整い次第お届け！' :
      '発送準備が整い次第お届け！'
  }

  generateKey(order: Order): string {
    return order.cartItems.map(c => c.id).join('_')
  }

  getDeliveryPlanLabel(order: Order): string {
    return this.isPreOrder(order) ? `${order.deliveryWhen}発送予定` : '順次発送予定'
  }

  @Emit('click')
  onClick() {
    // nothing
  }

  private isPreOrder(order: Order): boolean {
    return order.kind === OrderKind.PreOrder
  }
}
